import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegisterPageRoutingModule } from './register-routing.module';
import { RegisterPageComponent } from './register.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [RegisterPageComponent],
  imports: [
    CommonModule,
    RegisterPageRoutingModule,
    SharedModule
  ]
})
export class RegisterPageModule { }
